// ==========================================
// 🔔 ONESIGNAL - BORAFRETE
// ==========================================

const APP_ID = '4b1536b0-5ec8-4e52-a3ff-2ade71e108f3';

/**
 * Inicializa o OneSignal quando a página carrega
 */
export const initOneSignal = () => {
  window.OneSignal = window.OneSignal || [];
  
  window.OneSignal.push(() => {
    window.OneSignal.init({
      appId: APP_ID,
      allowLocalhostAsSecureOrigin: true, // Permite testar no localhost
      notifyButton: {
        enable: false, // Desabilita botão flutuante padrão do OneSignal
      },
      welcomeNotification: {
        title: 'BoraFrete 🚛',
        message: 'Você receberá alertas de cargas na sua região!',
      },
    });
  });
};

/**
 * Registra o motorista no OneSignal com email como ID
 * @param {string} email - Email do motorista
 * @param {string} estado - Estado para segmentação (opcional)
 */
export const registrarMotorista = (email, estado) => {
  if (!window.OneSignal || !email) return;
  
  window.OneSignal.push(() => {
    // Define ID externo = email (para enviar notificações específicas)
    window.OneSignal.setExternalUserId(email);
    
    // Adiciona tags para segmentação
    window.OneSignal.sendTags({
      tipo: 'motorista',
      estado: estado || '',
      plataforma: 'borafrete',
      data_registro: new Date().toISOString()
    });
    
    console.log('✅ Motorista registrado no OneSignal:', email);
  });
};

/**
 * Solicita permissão de notificação ao usuário
 */
export const solicitarPermissao = () => {
  if (!window.OneSignal) {
    console.log('OneSignal não carregado ainda');
    return;
  }
  
  window.OneSignal.showNativePrompt();
};

/**
 * Verifica se o usuário já deu permissão
 * @returns {Promise<string>} 'granted', 'denied' ou 'default'
 */
export const verificarPermissao = async () => {
  if (!window.OneSignal) return 'default';
  
  return await window.OneSignal.getNotificationPermission();
};

/**
 * Remove o registro do motorista (logout)
 */
export const removerRegistro = () => {
  if (!window.OneSignal) return;
  
  window.OneSignal.push(() => {
    window.OneSignal.removeExternalUserId();
    window.OneSignal.deleteTags(['tipo', 'estado', 'plataforma']);
  });
};